import RequestMailService from '@/services/environment/request-mail'

export default class EnvironmentService {
  get requestMail(): RequestMailService {
    return new RequestMailService()
  }
}
